__turbopack_context__.v({
  "ctaBanner": "PartLoadBooking-module-scss-module__JQUPEW__ctaBanner",
  "ctaBg": "PartLoadBooking-module-scss-module__JQUPEW__ctaBg",
  "ctaBtn": "PartLoadBooking-module-scss-module__JQUPEW__ctaBtn",
  "ctarow": "PartLoadBooking-module-scss-module__JQUPEW__ctarow",
  "herroSection": "PartLoadBooking-module-scss-module__JQUPEW__herroSection",
  "imageWrap": "PartLoadBooking-module-scss-module__JQUPEW__imageWrap",
  "imgBox": "PartLoadBooking-module-scss-module__JQUPEW__imgBox",
  "main": "PartLoadBooking-module-scss-module__JQUPEW__main",
  "textBox": "PartLoadBooking-module-scss-module__JQUPEW__textBox",
});
